import React, { useState, useEffect } from 'react';
import Layout from '../component/layout'
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from 'xlsx';
import { toastify } from '../../../utils/toast';
import { getItem, setItem } from '../../../utils/localStorage';
import ConfirmDialog from '../component/confirmDialog';
import { makeRequest2 } from '../../../utils/makeRequest';
import {
    getCustomerURL,
    getUnitsForFacility,
    getCustomerUnits,
    addUnoccupiedUnitToCustomer,
    updateCustomer,
    changeUserTypeURL,
    statementOfAccountsURL,
    uploadCustomerDocumentURL,
    getCustomerDocumentsURL,
    moveCustomerUrl,
    updateKinURL,
    addKinURL,
    getDocumentTypesURL,
    getBillerAddressesURL
} from '../../../utils/urls';
import { LOGO_BASE64 } from '../../../utils/logo64';
import { FileText, Image } from "lucide-react";

const ViewCustomer = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const { customerId } = useParams();
    const [customer, setCustomer] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [idNumber, setIdNumber] = useState('')
    const [email, setEmail] = useState('')
    const [customerType, setCustomerType] = useState('')
    const [status, setStatus] = useState('')
    const [units, setUnits] = useState([])
    const [customerUnits, setCustomerUnits] = useState([])
    const [selectedUnits, setSelectedUnits] = useState([])
    const [addUnitDialog, setAddUnitDialogVisible] = useState(false)
    const [isConfirmDialogVisible, setConfirmDialogVisible] = useState(false);
    const [confirmAction, setConfirmAction] = useState("");
    const [selectedCustomerId, setSelectedCustomerId] = useState('');
    const [showDialog, setShowDialog] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [agingData, setAgingData] = useState([]);
    const [documentModal, setDocumentModal] = useState(false);
    const [documentName, setDocumentName] = useState('');
    const [documentTypes, setDocumentTypes] = useState([]);
    const [documentType, setDocumentType] = useState('');
    const [file, setFile] = useState(null);
    const [customerDocuments, setCustomerDocuments] = useState([]);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [addKinModalVisible, setAddKinModalVisible] = useState(false);
    const [kraPin, setKraPin] = useState('');
    const [combineInvoices, setCombineInvoices] = useState(false);
    const [kinToEdit, setKinToEdit] = useState(null);
    const [newKin, setNewKin] = useState({
        name: "",
        relationship: "",
        phoneNumber: "",
        email: "",
        canReceiveInvoice: false
    });
    const [activeTab, setActiveTab] = useState('profile-1');
    const [infoVisible, setInfoVisible] = useState(activeTab === 'profile-1');
    const [billerAddressList, setBillerAddressList] = useState([]);
    const [facilityLogo, setFacilityLogo] = useState(
        () => localStorage.getItem("selectedFacilityLogo") || "",
    );

    console.log("facilityLogo:", facilityLogo);
    console.log("facilityLogo type:", typeof facilityLogo);

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        // Show info panel only when on profile-1 tab
        setInfoVisible(tabId === 'profile-1');
    };
    const toggleInfoPanel = () => {
        setInfoVisible(!infoVisible);
    };

    const getFacilityLogo = async () => {
        try {
            const facilityFromState = location.state?.facility;

            if (facilityFromState?.logo) {
                await setItem("selectedFacilityLogo", facilityFromState.logo);
                setFacilityLogo(facilityFromState.logo);
                return;
            }

            const storedLogo = await getItem("selectedFacilityLogo");
            setFacilityLogo(storedLogo || "");
        } catch (error) {
            console.error("Error fetching facility logo:", error);

            const fallbackLogo = localStorage.getItem("selectedFacilityLogo");
            setFacilityLogo(fallbackLogo || "");
        }
    };
    const addUnoccupiedUnit = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId')
            const data = {
                units: selectedUnits,
            };

            const response = await makeRequest2(`${addUnoccupiedUnitToCustomer}/${facilityId}/${customerId}`, 'POST', data);

            if (response.success) {
                toastify('Unit added successfully', 'success');
                setSelectedUnits([]);
                setAddUnitDialogVisible(false)
                getUnitsForCustomer();
                fetchUnits()
            }
            else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, 'error')
        }
    }
    const fetchUnits = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const response = await makeRequest2(`${getUnitsForFacility}/${facilityId}`, 'GET', {});

            if (response.success) {
                const filteredUnits = response.data.filter(unit => {
                    const isFullyOccupied = unit.homeOwnerId && unit.tenantId && unit.residentId;
                    const homeownerLivesThere = unit.homeOwnerId && unit.residentId;
                    const noHomeOwnerOrNoTenant = !unit.homeOwnerId || !unit.tenantId;
                    const homeownerWithoutTenantOrResident = unit.homeOwnerId && !unit.tenantId && !unit.residentId;

                    return !isFullyOccupied && !homeownerLivesThere && (noHomeOwnerOrNoTenant || homeownerWithoutTenantOrResident);
                });

                // Apply additional filtering based on customerType
                let finalUnits = filteredUnits;

                if (customerType === "home owner") {
                    // Show all unoccupied units and occupied units that have tenantId but no homeownerId
                    finalUnits = filteredUnits.filter(unit => !unit.homeOwnerId || unit.tenantId);
                } else if (customerType === "tenant") {
                    // Show only units with a homeownerId where the homeowner is non-resident
                    finalUnits = filteredUnits.filter(unit => {
                        return unit.homeOwnerId && !unit.tenantId && !unit.residentId;
                    });
                }

                setUnits(finalUnits);
            } else {
                throw new Error('Error fetching units');
            }
        } catch (err) {
            console.error('Error fetching units:', err);
        }
    };
    const getCustomer = async () => {
        try {
            const response = await makeRequest2(getCustomerURL + '/' + customerId, 'GET')

            if (response.success === true) {
                const customer = response.data;
                setCustomer(customer)
                setFirstName(customer.firstName);
                setLastName(customer.lastName);
                setPhoneNumber(customer.phoneNumber);
                setIdNumber(customer.idNumber);
                setEmail(customer.email);
                setCustomerType(customer.customerType);
                setStatus(customer.status);
                setKraPin(customer.kraPin || '');
                setCombineInvoices(customer.combineInvoices === true);
            }
            else {
                throw new Error(response.error)
            }
        }
        catch (err) {
            toastify(err.message, 'error')
        }
    }
    const handleAddKin = async () => {
        try {
            const response = await makeRequest2(addKinURL + '/' + customerId, 'POST', newKin)

            if (response.success) {
                toastify('Kin added successfully', 'success')
                setAddKinModalVisible(false);
                getCustomer()
            }
            else {
                throw new Error(response.error)
            }
        }
        catch (err) {
            toastify(err.message, 'error')
        }
    }
    const handleKinUpdate = async () => {
        try {
            const response = await makeRequest2(updateKinURL + '/' + customerId + '/' + kinToEdit._id, 'POST', kinToEdit)
            if (response.success) {
                toastify('Kin updated successfully', 'success')
                setKinToEdit(null)
                setEditModalVisible(false);
                getCustomer()
            }
            else {
                throw new Error(response.error)
            }
        }
        catch (err) {
            toastify(err.message, 'error')
        }
    }
    const getUnitsForCustomer = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId')
            const response = await makeRequest2(`${getCustomerUnits}/${facilityId}/${customerId}`, 'GET', {});

            if (response.success) {
                setCustomerUnits(response.data);

                if (response.data.length > 0 && response.data[0]._id) {
                    const unitId = response.data[0]._id;
                    await setItem('unitId', unitId);
                } else {
                    // Handle case where no units exist
                    await setItem('unitId', null);
                }
            }
        }
        catch (error) {
            toastify('Error fetching units: ' + error.message);
        }
    };
    const actionTemplate = (rowData) => {
        // For units with tenants, show "Proceed to Handover" button
        if (rowData.tenantId) {
            return (
                <Button
                    label="Proceed to Handover"
                    icon="pi pi-arrow-right"
                    className="p-button-primary"
                    style={{ borderRadius: "20px", padding: "8px 16px" }}
                    onClick={() => {
                        // Navigate to create move-out handover with pre-filled unit and tenant information
                        navigate(`/facility/handover_management/add_move_out_handover`, {
                            state: {
                                unitId: rowData._id,
                                unitName: rowData.name,
                                customerId: rowData.tenantId
                            }
                        });
                    }}
                />
            );
        }
        // For units without tenants (just homeowners), show "Finish Deactivation" button
        else {
            return (
                <Button
                    label="Finish Deactivation"
                    icon="pi pi-check"
                    className="p-button-danger"
                    style={{ borderRadius: "20px", padding: "8px 16px" }}
                    onClick={() => {
                        // If there's no tenant, the customer is a homeowner
                        // Navigate to create move-out handover with pre-filled unit and homeowner information
                        navigate(`/facility/handover_management/add_move_out_handover`, {
                            state: {
                                unitId: rowData._id,
                                unitName: rowData.name,
                                customerId: rowData.homeOwnerId || selectedCustomerId
                            }
                        });
                    }}
                />
            );
        }
    };
    const statusTemplate = (customer) => {
        const statusStyles = {
            Active: { color: '#28a745', backgroundColor: '#e9fbe9' }, // Green for Active
            Inactive: { color: '#dc3545', backgroundColor: '#fde9e9' } // Red for Inactive
        };

        const style = statusStyles[customer.status] || {
            color: '#6c757d',
            backgroundColor: '#f1f1f1',
        };

        return (
            <span
                style={{
                    ...style,
                    padding: '0.5em 1em',
                    borderRadius: '12px',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    display: 'inline-block',
                }}
            >
                {customer.status}
            </span>
        );
    };
    const isNonResidentHomeOwner = (customer) =>
        customer.customerType === "home owner" &&
        customer.residentType === "non-resident";

    const actionBodyTemplate = (customer) => {
        return (
            <div className="d-flex justify-content-center gap-3 mt-4">
                <button
                    className={`btn ${customer.status === "Inactive" ? "btn-success" : "btn-danger"} px-4 py-2`}
                    onClick={() => {
                        if (
                            customer.status === "Active" &&
                            isNonResidentHomeOwner(customer)
                        ) {
                            navigate(`/facility/customer_management/landlord_deactivation/${customer._id}`);
                            return;
                        }

                        setSelectedCustomerId(customer._id);
                        setConfirmAction(
                            customer.status === "Inactive" ? "activate" : "deactivate"
                        );
                        setConfirmDialogVisible(true);
                    }}
                >
                    {customer.status === "Inactive" ? "Activate" : "Deactivate"}
                </button>
            </div>
        );
    };
    const handleConfirmAction = async () => {
        setConfirmDialogVisible(false);

        if (confirmAction === "deactivate") {
            await handleDeactivate(selectedCustomerId);
        }
        if (confirmAction === "move") {
            await handleMoveTenant();
        }
    };
    const handleDeactivate = async (customerId) => {
        try {
            const facilityId = await getItem('selectedFacilityId')
            const response = await makeRequest2(`${getCustomerUnits}/${facilityId}/${customerId}`, 'GET', {});
            if (response.success) {
                setCustomerUnits(response.data);
                setShowDialog(true);
            }
        }
        catch (error) {
            toastify('Error fetching units: ' + error.message);
        }
    }
    const HandleCustomerUpdate = async () => {
        try {
            if (!firstName) {
                throw new Error("First name is required");
            }
            if (!lastName) {
                throw new Error("Last name is required");
            }
            if (!phoneNumber) {
                throw new Error("Phone number is required");
            }
            if (!idNumber) {
                throw new Error("ID number is required");
            }
            if (!email) {
                throw new Error("Email is required");
            }
            const updatedCustomer = {
                firstName,
                lastName,
                phoneNumber,
                idNumber,
                email,
                kraPin,
                combineInvoices,
            };

            const response = await makeRequest2(`${updateCustomer}/${customerId}`, 'POST', updatedCustomer);

            if (response.success) {
                toastify("customer updated successfully", 'success');
                setFirstName('');
                setLastName('');
                setPhoneNumber('');
                setIdNumber('');
                setEmail('');
                getCustomer();
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, 'error');
        }
    };
    const HandleChangeUserType = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId')
            const isLandlord = customer.residentType === 'non-resident';
            const confirmMsg = isLandlord
                ? 'Convert this Landlord to a Resident Homeowner? The unit will be updated accordingly.'
                : 'Convert this Resident Homeowner to a Landlord? They will no longer occupy the unit.';

            if (!window.confirm(confirmMsg)) return;

            const response = await makeRequest2(`${changeUserTypeURL}/${customerId}/${facilityId}`, 'POST', { isLandlord });

            if (response.success) {
                toastify("User type changed successfully", 'success');
                getCustomer();
            } else {
                throw new Error(response.error)
            }

        } catch (error) {
            toastify(error.message, 'error');
        }
    };
    const handleUnitClick = (rowData) => {
        return (
            <Link to={'/facility/unit_management/view_unit/' + rowData._id} style={{ color: 'royalblue' }}>
                {rowData.name}
            </Link>
        )
    }
    const fetchStatementOfAccounts = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');

            const response = await makeRequest2(`${statementOfAccountsURL}/${facilityId}/${customerId}`, "GET", {});

            if (response.success) {
                setTransactions(response.data.transactions);
                setAgingData([response.data.agingSummary]);
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, "error");
        }
    };
    const fetchDocumentTypes = async () => {
        try {
            const facilityId = await getItem("selectedFacilityId");
            const response = await makeRequest2(`${getDocumentTypesURL}/${facilityId}`, "GET");

            if (response.success) {
                const dataArray =
                    response.data?.data && Array.isArray(response.data.data)
                        ? response.data.data
                        : Array.isArray(response.data)
                            ? response.data
                            : [];

                setDocumentTypes(dataArray);
            } else {
                toastify("Failed to load document types", "error");
            }
        } catch (error) {
            toastify(error.message, "error");
        }
    };
    const handleDocumentSubmit = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');

            const formData = new FormData();
            formData.append('documentName', documentName);
            formData.append('documentType', documentType);
            if (file) {
                formData.append('file', file);
            }

            const response = await makeRequest2(`${uploadCustomerDocumentURL}/${facilityId}/${customerId}`, 'POST', formData);

            if (response.success) {
                toastify('Document added successfully', 'success');
                setDocumentName('');
                setDocumentType('');
                setFile(null);
                setDocumentModal(false);
                getCustomerDocuments();
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, 'error')
        }
    }
    const getCustomerDocuments = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');

            const response = await makeRequest2(`${getCustomerDocumentsURL}/${facilityId}/${customerId}`, 'GET', {});

            if (response.success) {
                setCustomerDocuments(response.data.documents);
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, 'error')
        }
    }
    const renderDocument = (rowData) => {
        if (!rowData.document) return "No document";

        const fileUrl = `${rowData.document}`;
        const isImage = rowData.document.match(/\.(jpeg|jpg|png|gif)$/i); // Check if it's an image

        return (
            <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center text-primary"
                style={{ textDecoration: "none", gap: "5px" }}
            >
                {isImage ? <Image size={18} /> : <FileText size={18} />}
                View Document
            </a>
        );
    };
    const formatDate = (dateString) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    const formatCurrency = (amount, currencyCode = 'KES') => {
        if (typeof amount !== 'number') return `${currencyCode} 0.00`;
        return `${currencyCode} ${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };
    const fetchBillerAddresses = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const response = await makeRequest2(`${getBillerAddressesURL}/${facilityId}`, 'GET');

            if (response && response.success && response.data) {
                // Handle both array and object responses
                let addresses = [];
                if (Array.isArray(response.data)) {
                    addresses = response.data;
                } else if (typeof response.data === 'object' && response.data !== null) {
                    // If it's an object, try to extract array from common properties
                    if (response.data.data && Array.isArray(response.data.data)) {
                        addresses = response.data.data;
                    } else if (response.data.addresses && Array.isArray(response.data.addresses)) {
                        addresses = response.data.addresses;
                    } else {
                        // If it's a single object, wrap it in an array
                        addresses = [response.data];
                    }
                }
                setBillerAddressList(addresses);
            } else if (response && response.data) {
                let addresses = [];
                if (Array.isArray(response.data)) {
                    addresses = response.data;
                } else if (typeof response.data === 'object' && response.data !== null) {
                    addresses = [response.data];
                }
                setBillerAddressList(addresses);
            } else {
                setBillerAddressList([]);
            }
        } catch (error) {
            toastify('Failed to fetch biller addresses', 'error');
            setBillerAddressList([]);
        }
    };
    const getDefaultBillerAddress = () => {
        if (!billerAddressList?.length) {
            return null;
        }

        return (
            billerAddressList.find(address => address.isDefault) ||
            billerAddressList[0]
        );
    };
    const exportPDF = async () => {
        const doc = new jsPDF();

        const currentDate = formatDate(new Date());

        const firstName = customer.firstName;
        const lastName = customer.lastName;
        const fullName = `${firstName} ${lastName}`;

        const billerAddress = billerAddressList.find(
            address => address.isDefault
        ) || billerAddressList[0];

        const companyName = billerAddress?.companyName || "Company";
        const address = billerAddress?.address || "";
        const city = billerAddress?.city || "";
        const country = billerAddress?.country || "";
        const email = billerAddress?.email || "";

        // ---------- number helpers ----------
        const toNum = (value) => {
            if (value === null || value === undefined) return 0;
            if (typeof value === 'number') return isNaN(value) ? 0 : value;
            if (typeof value === 'string') {
                const n = parseFloat(value.replace(/[^0-9.-]+/g, ""));
                return isNaN(n) ? 0 : n;
            }
            return 0;
        };

        const formatCurrencyForPDF = (value) =>
            toNum(value).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

        // Signed format for the Net Balance / Current Balance line
        const formatSignedCurrency = (value) => {
            const n = toNum(value);
            const abs = Math.abs(n).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return n < 0 ? `- ${abs}` : `${abs}`;
        };

        // Logo - failure must not prevent PDF export
        const logoBase64 = facilityLogo;

        if (logoBase64) {
            try {
                doc.addImage(logoBase64, 'PNG', 14, 10, 40, 20);
            } catch (error) {
                console.warn(
                    "Facility logo could not be added to PDF. Continuing without logo.",
                    error
                );
            }
        }

        // ---------- header ----------
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 78, 152);
        doc.text(companyName, 195, 15, { align: 'right' });

        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(0, 0, 0);

        const location = [address, city, country].filter(Boolean).join(', ');
        if (location) doc.text(location, 195, 25, { align: 'right' });
        if (email) doc.text(`Email: ${email}`, 195, 30, { align: 'right' });

        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 78, 152);
        doc.text(`${fullName} - STATEMENT OF ACCOUNT`, 14, 45);

        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        doc.text(`Date: ${currentDate}`, 14, 55);

        // ---------- totals (single source of truth) ----------
        const totalDebit = transactions.reduce((sum, t) => sum + toNum(t.debit), 0);
        const totalCreditAll = transactions.reduce((sum, t) => sum + toNum(t.credit), 0);
        const totalOverpayment = transactions
            .filter(t => t.isOverpayment)
            .reduce((sum, t) => sum + toNum(t.credit), 0);

        // "Payments" = credits excluding overpayment (what was actually applied to invoices)
        const totalPaymentsApplied = totalCreditAll - totalOverpayment;

        // Running balance from the LAST (most recent) entry — matches the UI table
        const lastRow = transactions.length > 0
            ? transactions[transactions.length - 1]
            : null;
        const runningBalance = lastRow ? toNum(lastRow.balance) : 0;

        // Positive runningBalance = customer owes; negative = customer is in credit
        const isCredit = runningBalance < 0;
        const displayBalance = formatSignedCurrency(runningBalance);
        const balanceLabel = isCredit
            ? `Current Balance: KES ${displayBalance} CREDIT`
            : `Current Balance: KES ${displayBalance} OWING`;

        // Account summary - right aligned
        doc.setFont('helvetica', 'bold');
        doc.text(balanceLabel, 195, 55, { align: 'right' });
        doc.setFont('helvetica', 'normal');

        // ---------- transaction table ----------
        // Keep the backend order (oldest first, invoices before payments on the same
        // date) so the PDF matches the UI table exactly.
        const orderedTransactions = transactions;

        const headers = [[
            "Date",
            "Transaction Ref",
            "Details",
            "Debit (KES)",
            "Credit (KES)",
            "Balance (KES)"
        ]];

        const data = orderedTransactions.map(t => [
            formatDate(t.date),
            t.transactionRef,
            t.details,
            toNum(t.debit) ? formatCurrencyForPDF(t.debit) : "",
            toNum(t.credit) ? formatCurrencyForPDF(t.credit) : "",
            formatSignedCurrency(t.balance)
        ]);

        autoTable(doc, {
            startY: 65,
            head: headers,
            body: data,
            styles: { fontSize: 9 },
            headStyles: {
                fillColor: [0, 78, 152],
                fontSize: 9,
                fontStyle: 'bold',
                halign: 'center'
            },
            columnStyles: {
                0: { cellWidth: 25 },
                1: { cellWidth: 30 },
                2: { cellWidth: 50 },
                3: { cellWidth: 25, halign: 'right' },
                4: { cellWidth: 25, halign: 'right' },
                5: { cellWidth: 25, halign: 'right' }
            },
            alternateRowStyles: { fillColor: [240, 240, 240] },
            margin: { top: 65 },
            // Highlight overpayment rows in purple so they stand out like the UI badge
            didParseCell: (data) => {
                if (data.section === 'body' && data.row.index >= 0) {
                    const row = orderedTransactions[data.row.index];
                    if (row?.isOverpayment) {
                        data.cell.styles.fillColor = [245, 235, 255];
                        data.cell.styles.textColor = [110, 40, 160];
                    }
                }
            }
        });

        // ---------- summary table ----------
        const transactionTableY = doc.lastAutoTable.finalY;

        const summaryData = [
            ["Total Invoiced:", `KES ${formatCurrencyForPDF(totalDebit)}`],
            ["Total Payments:", `KES ${formatCurrencyForPDF(totalPaymentsApplied)}`]
        ];

        if (totalOverpayment > 0) {
            summaryData.push([
                "Overpayment:",
                `KES ${formatCurrencyForPDF(totalOverpayment)}`
            ]);
        }

        summaryData.push([
            isCredit ? "Current Balance (Credit):" : "Current Balance (Owing):",
            `KES ${displayBalance}`
        ]);

        autoTable(doc, {
            startY: transactionTableY + 10,
            body: summaryData,
            theme: 'plain',
            styles: { fontSize: 10 },
            columnStyles: {
                0: { cellWidth: 100, fontStyle: 'bold', textColor: [0, 78, 152] },
                1: { cellWidth: 50, halign: 'right', fontStyle: 'bold' }
            },
            // Color the balance row: purple when in credit, red when owing
            didParseCell: (data) => {
                if (data.section === 'body') {
                    if (data.row.index === summaryData.length - 1) {
                        data.cell.styles.textColor = isCredit ? [110, 40, 160] : [185, 28, 28];
                    }
                    const label = summaryData[data.row.index][0];
                    if (label === 'Overpayment:') {
                        data.cell.styles.textColor = [110, 40, 160];
                    }
                }
            }
        });

        // ---------- aging ----------
        const summaryTableY = doc.lastAutoTable.finalY;

        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 78, 152);
        doc.text("Aging Summary", 14, summaryTableY + 20);

        const agingHeaders = [[
            "15 Days", "30 Days", "60 Days", "90+ Days", "Total Outstanding"
        ]];
        const agingRows = agingData.length > 0 ? [[
            formatCurrencyForPDF(agingData[0].aging15),
            formatCurrencyForPDF(agingData[0].aging30),
            formatCurrencyForPDF(agingData[0].aging60),
            formatCurrencyForPDF(agingData[0].aging90),
            formatCurrencyForPDF(agingData[0].totalOutstanding)
        ]] : [["0.00", "0.00", "0.00", "0.00", "0.00"]];

        autoTable(doc, {
            startY: summaryTableY + 25,
            head: agingHeaders,
            body: agingRows,
            styles: { fontSize: 9, halign: 'right' },
            headStyles: {
                fillColor: [0, 78, 152],
                fontStyle: 'bold',
                halign: 'center'
            },
            theme: 'grid',
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });

        // Optional: surface the overpayment credit below the aging table
        if (totalOverpayment > 0) {
            const overpayY = doc.lastAutoTable.finalY + 10;
            doc.setFontSize(9);
            doc.setFont('helvetica', 'italic');
            doc.setTextColor(110, 40, 160);
            doc.text(
                `Overpayment credit available: KES ${formatCurrencyForPDF(totalOverpayment)}`,
                14,
                overpayY
            );
            doc.setTextColor(0, 0, 0);
            doc.setFont('helvetica', 'normal');
        }

        doc.save(`statement_of_account_${currentDate.replace(/\//g, '-')}.pdf`);
    };
    const handleMoveTenant = async () => {
        try {
            const newUnitId = selectedUnits[0]?._id;
            const facilityId = await getItem('selectedFacilityId')
            const unitId = await getItem('unitId')

            const response = await makeRequest2(`${moveCustomerUrl}/${facilityId}`, 'POST', { customerId, unitId, newUnitId })
            if (response.success) {
                toastify('Tenant moved successfully, Please proceed to create a new lease agreement', 'success')
                setSelectedUnits([])
                getCustomer()
            } else {
                throw new Error(response.error)
            }

        } catch (err) {
            toastify(err.message, 'error')
        }
    }

    useEffect(() => {
        getCustomer(); // Fetch customer first
        fetchBillerAddresses();
        getDefaultBillerAddress();
        getFacilityLogo();
    }, []);

    // once customerType is available, fetch units
    useEffect(() => {
        if (customerType) {
            const fetchData = async () => {
                await fetchUnits();
                await getUnitsForCustomer();
                // Now that unitId is set, fetch the dependent data
                await fetchStatementOfAccounts();
                await fetchDocumentTypes();
                await getCustomerDocuments();
            };

            fetchData();
        }
    }, [customerType]);

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/core/dashboard/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/customer_management/customers"}>Customer  Management</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>View Customer</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="d-inline-block">
                                <div className="card">
                                    <div className="card-header px-3 py-2">
                                        <Link to="#" onClick={() => navigate(-1)}>
                                            <i className="ti ti-arrow-narrow-left"></i> <span>Back</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="customer-profile-container">
                                <div className="card mb-3">
                                    <div className="card-body py-0">
                                        <ul className="nav nav-tabs profile-tabs" id="myTab" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link cursor-pointer ${activeTab === 'profile-1' ? 'active' : ''}`}
                                                    id="profile-tab-1"
                                                    onClick={() => handleTabClick('profile-1')}
                                                    role="tab"
                                                    aria-selected={activeTab === 'profile-1'}
                                                >
                                                    <i className="ti ti-building-bank me-2"></i>Info
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link cursor-pointer ${activeTab === 'profile-2' ? 'active' : ''}`}
                                                    id="profile-tab-2"
                                                    onClick={() => handleTabClick('profile-2')}
                                                    role="tab"
                                                    aria-selected={activeTab === 'profile-2'}
                                                >
                                                    <i className="ti ti-building-warehouse me-2"></i>Unit
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link cursor-pointer ${activeTab === 'profile-3' ? 'active' : ''}`}
                                                    id="profile-tab-3"
                                                    onClick={() => handleTabClick('profile-3')}
                                                    role="tab"
                                                    aria-selected={activeTab === 'profile-3'}
                                                >
                                                    <i className="ti ti-file-text me-2"></i>Documents
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link cursor-pointer ${activeTab === 'profile-4' ? 'active' : ''}`}
                                                    id="profile-tab-6"
                                                    onClick={() => handleTabClick('profile-4')}
                                                    role="tab"
                                                    aria-selected={activeTab === 'profile-4'}
                                                >
                                                    <i className="ti ti-receipt me-2"></i>Statement of Accounts
                                                </button>
                                            </li>

                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link cursor-pointer ${activeTab === 'profile-5' ? 'active' : ''}`}
                                                    id="profile-tab-7"
                                                    onClick={() => handleTabClick('profile-5')}
                                                    role="tab"
                                                    aria-selected={activeTab === 'profile-5'}
                                                >
                                                    <i className="ti ti-arrows-right-left me-2"></i>Move Tenant
                                                </button>
                                            </li>

                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link cursor-pointer ${activeTab === 'profile-6' ? 'active' : ''}`}
                                                    id="profile-tab-5"
                                                    onClick={() => handleTabClick('profile-6')}
                                                    role="tab"
                                                    aria-selected={activeTab === 'profile-6'}
                                                >
                                                    <i className="ti ti-settings me-2"></i>Settings
                                                </button>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                                <div className="row">
                                    {(activeTab === 'profile-1' || infoVisible) && (
                                        <div className="col-lg-4 col-xxl-3">
                                            <div className="card">
                                                <div className="card-header d-flex justify-content-between align-items-center py-2">
                                                    <h5 className="m-0">Customer Information</h5>
                                                    {/* Only show hide button if NOT in profile-1 */}
                                                    {activeTab !== 'profile-1' && (
                                                        <button
                                                            className="btn btn-sm btn-light"
                                                            onClick={toggleInfoPanel}
                                                            title="Hide Info Panel"
                                                        >
                                                            <i className="ti ti-chevron-left"></i>
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="card-body position-relative">
                                                    <div className="text-center mt-3">
                                                        <div className="chat-avtar d-inline-flex mx-auto">
                                                            <i className="ti ti-user me-2" style={{ fontSize: 100 }}></i>
                                                        </div>
                                                        <h5 className="mb-0"></h5>
                                                        <h2 className="text-muted mt-2">{customer.firstName} {customer.lastName}</h2>

                                                        <hr className="my-3 border border-secondary-subtle" />

                                                        <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                                                            <p className="mb-0"><strong>Email: </strong>{customer.email}</p>
                                                        </div>
                                                        <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                                                            <p className="mb-0"><strong>Phone No.: </strong>{customer.phoneNumber}</p>
                                                        </div>
                                                        <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                                                            <p className="mb-0"><strong>ID No: </strong>{customer.idNumber}</p>
                                                        </div>
                                                        <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                                                            <p className="mb-0"><strong>Type: </strong>{customer.customerType}</p>
                                                        </div>
                                                        <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                                                            <p className="mb-0"><strong>Resident: </strong>{customer.residentType}</p>
                                                        </div>
                                                        <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                                                            <p className="mb-0"><strong>Status: </strong>{statusTemplate(customer)}</p>
                                                        </div>
                                                        {customer.customerKind === "Business" && (
                                                            <>
                                                                <hr className="my-3 border border-secondary-subtle" />

                                                                <div className="text-start mb-3">
                                                                    <h6 className="fw-bold mb-3">
                                                                        <i className="ti ti-building me-2"></i>
                                                                        Business Information
                                                                    </h6>

                                                                    <div className="d-flex align-items-center justify-content-start w-100 mb-3">
                                                                        <p className="mb-0">
                                                                            <strong>Company Name: </strong>
                                                                            {customer.companyName}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {actionBodyTemplate(customer)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/* Next of Kin Column - only render when needed */}
                                    {activeTab === 'profile-1' && (
                                        customer.nextOfKin?.some(kin => kin.name || kin.phoneNumber || kin.email) ? (
                                            <div className="col-lg-4 col-xxl-4">
                                                <div className="card">
                                                    <div className="card-header d-flex justify-content-between align-items-center py-2">
                                                        <h5 className="m-0">Other Contacts</h5>
                                                        <button
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={() => setAddKinModalVisible(true)}
                                                        >
                                                            <i className="ti ti-plus me-2"></i>Add
                                                        </button>
                                                    </div>
                                                    <div className="card-body">
                                                        {customer.nextOfKin.map((kin, index) => (
                                                            <div
                                                                key={kin._id || index}
                                                                className="border rounded p-3 mb-3 bg-light-subtle"
                                                            >
                                                                <p className="mb-1"><strong>Name:</strong> {kin.name}</p>
                                                                <p className="mb-1"><strong>Relationship:</strong> {kin.relationship}</p>
                                                                <p className="mb-1"><strong>Phone:</strong> {kin.phoneNumber}</p>
                                                                <p className="mb-1"><strong>Email:</strong> {kin.email}</p>
                                                                <p className="mb-0">
                                                                    <strong>Can Receive Invoice:</strong> {kin.canReceiveInvoice ? 'Yes' : 'No'}
                                                                </p>
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary mt-3"
                                                                    onClick={() => {
                                                                        setKinToEdit(kin);
                                                                        setEditModalVisible(true);
                                                                    }}
                                                                >
                                                                    <i className="ti ti-edit me-2"></i>Edit
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="col-lg-4 col-xxl-4">
                                                <div className="card">
                                                    <div className="card-header d-flex justify-content-between align-items-center py-2">
                                                        <h5 className="m-0">Other Contacts</h5>
                                                        <button
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={() => setAddKinModalVisible(true)}
                                                        >
                                                            <i className="ti ti-plus me-2"></i>Add
                                                        </button>
                                                    </div>
                                                    <div className="card-body">
                                                        <p>No Other Contacts added yet.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    )}

                                    {editModalVisible && kinToEdit && (
                                        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">Edit Contact</h5>
                                                        <button type="button" className="btn-close" onClick={() => setEditModalVisible(false)}></button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="mb-3">
                                                            <label className="form-label">Name</label>
                                                            <input type="text" className="form-control" value={kinToEdit.name} onChange={(e) => setKinToEdit({ ...kinToEdit, name: e.target.value })} />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Relationship</label>
                                                            <input type="text" className="form-control" value={kinToEdit.relationship} onChange={(e) => setKinToEdit({ ...kinToEdit, relationship: e.target.value })} />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Phone</label>
                                                            <input type="text" className="form-control" value={kinToEdit.phoneNumber} onChange={(e) => setKinToEdit({ ...kinToEdit, phoneNumber: e.target.value })} />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Email</label>
                                                            <input type="email" className="form-control" value={kinToEdit.email} onChange={(e) => setKinToEdit({ ...kinToEdit, email: e.target.value })} />
                                                        </div>

                                                        <div className="form-check mb-3">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="canReceiveInvoice"
                                                                checked={kinToEdit.canReceiveInvoice}
                                                                onChange={(e) => setKinToEdit({ ...kinToEdit, canReceiveInvoice: e.target.checked })}
                                                            />
                                                            <label className="form-check-label" htmlFor="canReceiveInvoice">Can Receive Invoice</label>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button className="btn btn-secondary" onClick={() => setEditModalVisible(false)}>Cancel</button>
                                                        <button
                                                            className="btn btn-success"
                                                            onClick={() => {
                                                                handleKinUpdate(kinToEdit);
                                                                setEditModalVisible(false);
                                                            }}
                                                        >
                                                            Save Changes
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/* Tab Content Area - Expands when info is hidden */}
                                    <div className={`col-lg-${infoVisible ? '8' : '12'} col-xxl-${infoVisible ? '9' : '12'}`}>
                                        {/* Show Info Button when Info Panel is Hidden */}
                                        {!infoVisible && (
                                            <button
                                                className="btn btn-primary mb-3"
                                                onClick={toggleInfoPanel}
                                                title="Show Info Panel"
                                            >
                                                <i className="ti ti-user me-2"></i>Show Customer Info
                                            </button>
                                        )}
                                        {/* Tab Content */}
                                        <div className="tab-content">
                                            {activeTab === 'profile-2' && (
                                                <div className="card">
                                                    <div className="card-header">
                                                        <div>
                                                            <div style={{ float: 'right' }}>
                                                                <button className="btn btn-primary"
                                                                    onClick={() => { setAddUnitDialogVisible(true) }}
                                                                ><i className="ti ti-circle-plus me-2"></i> Add Unit</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="tab-content" id="nav-tabContent">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <DataTable value={customerUnits} emptyMessage="No units found." sortMode="multiple" paginator rows={10} stripedRows tableStyle={{ minWidth: '50rem' }}>
                                                                            <Column field="name" body={handleUnitClick} header="Name"></Column>
                                                                            <Column field="unitType" header="Type"></Column>
                                                                            <Column field="floorUnitNo" header="Floor/Unit"></Column>
                                                                            <Column field="lettableFloorArea" header="LFA"></Column>
                                                                            <Column field="landRateNumber" header="LRN"></Column>
                                                                            <Column field="grossArea" header="GA"></Column>
                                                                            <Column field="netLettableArea" header="NLA"></Column>
                                                                        </DataTable>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {activeTab === 'profile-3' && (
                                                <div className="container mt-4">
                                                    <div className="row">
                                                        <div className="col-12 d-flex justify-content-between">
                                                            <h5>Customer Documents</h5>
                                                            <Button label="Add Document" icon="pi pi-plus" onClick={() => setDocumentModal(true)} />
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-12">
                                                            <DataTable value={customerDocuments} paginator rows={5} emptyMessage="No documents found.">
                                                                <Column field="documentName" header="Document Name"></Column>
                                                                <Column
                                                                    header="Document Type"
                                                                    body={(rowData) => rowData.documentType?.name || "N/A"}
                                                                ></Column>
                                                                <Column header="Document" body={(rowData) => renderDocument(rowData)}></Column>
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                    {/* Modal for Adding Document */}
                                                    <Dialog header="Add Document" visible={documentModal} style={{ width: "400px" }} onHide={() => setDocumentModal(false)}>
                                                        <div className="p-fluid">
                                                            <div className="field mb-3">
                                                                <label className='form-label'>Document Name</label>
                                                                <InputText value={documentName} onChange={(e) => setDocumentName(e.target.value)} />
                                                            </div>
                                                            <div className="field mb-3">
                                                                <label className='form-label'>Document Type</label>
                                                                <select
                                                                    className="form-control"
                                                                    value={documentType}
                                                                    onChange={(e) => setDocumentType(e.target.value)}
                                                                >
                                                                    <option value="">Select Document Type</option>
                                                                    {documentTypes.map((type) => (
                                                                        <option key={type._id} value={type._id}>
                                                                            {type.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="field mb-3">
                                                                <label className='form-label'>Upload Document</label>
                                                                <input
                                                                    type="file"
                                                                    className="form-control"
                                                                    onChange={(e) => setFile(e.target.files[0])}
                                                                />
                                                            </div>
                                                            <div className="d-flex justify-content-end mt-3">
                                                                <Button label="Cancel" className="p-button-text" onClick={() => setDocumentModal(false)} />
                                                                <Button label="Save" className="p-button-primary ms-2" onClick={handleDocumentSubmit} />
                                                            </div>
                                                        </div>
                                                    </Dialog>
                                                </div>
                                            )}

                                            {activeTab === 'profile-4' && (
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="tab-content" id="nav-tabContent">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <div className="mb-4 p-3 border rounded-1 shadow-sm bg-white">
                                                                            <div className="card-header d-flex justify-content-between align-items-start">
                                                                                <h5 className="m-0">Transactions</h5>

                                                                                <div className="d-flex">
                                                                                    {/* <Button type="button" label="CSV" rounded onClick={exportCSV} data-pr-tooltip="CSV" /> */}
                                                                                    {/* <Button type="button" label="XLS" severity="success" rounded onClick={exportXLSX} data-pr-tooltip="XLS" /> */}
                                                                                    <Button type="button" label="PDF" severity="warning" rounded onClick={exportPDF} data-pr-tooltip="PDF" />
                                                                                </div>
                                                                            </div>
                                                                            <div className='table-responsive'>
                                                                                <DataTable
                                                                                    value={transactions}
                                                                                    emptyMessage="No transactions found."
                                                                                    sortMode="multiple"
                                                                                    sortField="date"           // Set default sort field
                                                                                    sortOrder={1}             // -1 for descending order
                                                                                    removableSort={true}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    stripedRows
                                                                                    className="shadow-md rounded-lg overflow-hidden"
                                                                                    // rowClassName="hover:bg-gray-50 transition-colors"
                                                                                    rowClassName={(data) =>
                                                                                        data.isOverpayment
                                                                                            ? "bg-purple-50 hover:bg-purple-100 transition-colors"
                                                                                            : "hover:bg-gray-50 transition-colors"
                                                                                    }
                                                                                    footer={
                                                                                        <div className="p-3 bg-gray-50 border-t">
                                                                                            <div className="text-sm text-gray-500 mb-2">
                                                                                                Showing {transactions?.length || 0} transactions
                                                                                            </div>
                                                                                            <div className="row fw-bold">
                                                                                                <div className="col">
                                                                                                    <span className="text-muted">Totals:</span>
                                                                                                </div>
                                                                                                <div className="col text-end">
                                                                                                    <span className="text-red-600">
                                                                                                        Debit: {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' }).format(
                                                                                                            transactions?.reduce((sum, t) => sum + (parseFloat(t.debit) || 0), 0) || 0
                                                                                                        )}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="col text-end">
                                                                                                    <span className="text-green-600">
                                                                                                        Credit: {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' }).format(
                                                                                                            transactions?.reduce((sum, t) => sum + (parseFloat(t.credit) || 0), 0) || 0
                                                                                                        )}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="col text-end">
                                                                                                    <span className="text-purple-600">
                                                                                                        Overpaid: {
                                                                                                            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' }).format(
                                                                                                                transactions
                                                                                                                    ?.filter(t => t.isOverpayment)
                                                                                                                    .reduce((sum, t) => sum + (parseFloat(t.credit) || 0), 0) || 0
                                                                                                            )
                                                                                                        }
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="col text-end">
                                                                                                    {(() => {
                                                                                                        const totalCredit = transactions?.reduce((sum, t) => sum + (parseFloat(t.credit) || 0), 0) || 0;
                                                                                                        const totalDebit = transactions?.reduce((sum, t) => sum + (parseFloat(t.debit) || 0), 0) || 0;

                                                                                                        const netBalance = totalDebit - totalCredit; // positive = owing, negative = overpaid
                                                                                                        const isOverpaid = netBalance < 0;

                                                                                                        const displayValue = isOverpaid
                                                                                                            ? `+ ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' })
                                                                                                                .format(Math.abs(netBalance))} CREDIT`
                                                                                                            : `${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' })
                                                                                                                .format(netBalance)} OWING`;

                                                                                                        return (
                                                                                                            <span className={isOverpaid ? "text-blue-600 font-bold" : "text-red-600"}>
                                                                                                                Net Balance: {displayValue}
                                                                                                            </span>
                                                                                                        );
                                                                                                    })()}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transactions"
                                                                                    rowsPerPageOptions={[10, 15, 25, 50, 100]}
                                                                                >
                                                                                    <Column
                                                                                        field="date"
                                                                                        header="Date"
                                                                                        body={(rowData) => formatDate(rowData.date)}
                                                                                        headerClassName="bg-blue-100 font-bold"
                                                                                        sortable
                                                                                    />
                                                                                    <Column
                                                                                        field="transactionRef"
                                                                                        header="Transaction Ref"
                                                                                        headerClassName="bg-blue-100 font-bold"
                                                                                        body={(rowData) => {
                                                                                            const invoiceId = rowData._id;
                                                                                            const type = rowData.invoiceType?.toLowerCase();

                                                                                            // Early return if essential data is missing
                                                                                            if (!invoiceId || !rowData.transactionRef) {
                                                                                                return <span className="text-gray-400 italic">No Ref</span>;
                                                                                            }

                                                                                            let link = '';
                                                                                            switch (type) {
                                                                                                case 'contract':
                                                                                                    link = `/facility/levy_management/invoice/${invoiceId}`;
                                                                                                    break;
                                                                                                case 'lease':
                                                                                                    link = `/facility/lease_management/invoice/${invoiceId}`;
                                                                                                    break;
                                                                                                default:
                                                                                                    link = `/facility/levy_management/invoice/${invoiceId}`;
                                                                                                    break;
                                                                                            }

                                                                                            return (
                                                                                                <Link
                                                                                                    to={link}
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                    }}
                                                                                                    className="text-blue-600 underline hover:text-blue-800"
                                                                                                >
                                                                                                    {rowData.transactionRef}
                                                                                                </Link>
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                    <Column
                                                                                        field="details"
                                                                                        header="Details"
                                                                                        headerClassName="bg-blue-100 font-bold"
                                                                                        sortable
                                                                                        body={(rowData) => (
                                                                                            <span className="flex items-center gap-2">
                                                                                                {rowData.details}
                                                                                                {rowData.isOverpayment && (
                                                                                                    <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-purple-100 text-purple-700">
                                                                                                        Overpayment
                                                                                                    </span>
                                                                                                )}
                                                                                            </span>
                                                                                        )}
                                                                                    />
                                                                                    <Column
                                                                                        field="debit"
                                                                                        header="Debit"
                                                                                        headerClassName="bg-blue-100 font-bold"
                                                                                        body={(rowData) => rowData.debit && (
                                                                                            <span className="text-red-600 font-medium">
                                                                                                {typeof rowData.debit === 'number' ?
                                                                                                    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' }).format(rowData.debit) :
                                                                                                    rowData.debit}
                                                                                            </span>
                                                                                        )}
                                                                                        sortable
                                                                                    />
                                                                                    <Column
                                                                                        field="credit"
                                                                                        header="Credit"
                                                                                        headerClassName="bg-blue-100 font-bold"
                                                                                        body={(rowData) => rowData.credit && (
                                                                                            <span className={rowData.isOverpayment ? "text-purple-600 font-medium" : "text-green-600 font-medium"}>
                                                                                                {typeof rowData.credit === 'number'
                                                                                                    ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' }).format(rowData.credit)
                                                                                                    : rowData.credit}
                                                                                            </span>
                                                                                        )}
                                                                                        sortable
                                                                                    />
                                                                                    <Column
                                                                                        field="balance"
                                                                                        header="Balance"
                                                                                        headerClassName="bg-blue-100 font-bold"
                                                                                        body={(rowData) => (
                                                                                            <span className={`font-medium ${parseFloat(rowData.balance) < 0 ? 'text-blue-600' : 'text-red-600'}`}>
                                                                                                {typeof rowData.balance === 'number' ?
                                                                                                    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' }).format(rowData.balance) :
                                                                                                    rowData.balance}
                                                                                            </span>
                                                                                        )}
                                                                                        sortable
                                                                                    />
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-12">
                                                                        <div className="mb-4 p-3 border rounded-1 shadow-sm bg-white">
                                                                            <h4 className="mb-3">Overdue Aging Summary</h4>
                                                                            <div className='table-responsive'>
                                                                                <DataTable
                                                                                    value={agingData}
                                                                                    emptyMessage="No overdue invoices."
                                                                                    tableStyle={{ minWidth: '40rem' }}
                                                                                >
                                                                                    <Column field="aging15" header="15 Days" body={(rowData) => {
                                                                                        const amount = rowData.aging15;
                                                                                        return (
                                                                                            <span className={amount > 0 ? 'text-red-500' : ''}>
                                                                                                {formatCurrency(amount)}
                                                                                            </span>
                                                                                        );
                                                                                    }}
                                                                                        headerClassName="bg-blue-100 font-bold" />
                                                                                    <Column field="aging30" header="30 Days" body={(rowData) => {
                                                                                        const amount = rowData.aging30;
                                                                                        return (
                                                                                            <span className={amount > 0 ? 'text-red-500' : ''}>
                                                                                                {formatCurrency(amount)}
                                                                                            </span>
                                                                                        );
                                                                                    }}
                                                                                        headerClassName="bg-blue-100 font-bold" />
                                                                                    <Column field="aging60" header="60 Days" body={(rowData) => {
                                                                                        const amount = rowData.aging60;
                                                                                        return (
                                                                                            <span className={amount > 0 ? 'text-red-500' : ''}>
                                                                                                {formatCurrency(amount)}
                                                                                            </span>
                                                                                        );
                                                                                    }}
                                                                                        headerClassName="bg-blue-100 font-bold" />
                                                                                    <Column field="aging90" header="90+ Days" body={(rowData) => {
                                                                                        const amount = rowData.aging90;
                                                                                        return (
                                                                                            <span className={amount > 0 ? 'text-red-500' : ''}>
                                                                                                {formatCurrency(amount)}
                                                                                            </span>
                                                                                        );
                                                                                    }}
                                                                                        headerClassName="bg-blue-100 font-bold" />
                                                                                    <Column field="totalOutstanding" header="Total Outstanding" body={(rowData) => {
                                                                                        const amount = rowData.totalOutstanding;
                                                                                        return (
                                                                                            <span className={amount > 0 ? 'text-red-500 font-bold' : ''}>
                                                                                                {formatCurrency(amount)}
                                                                                            </span>
                                                                                        );
                                                                                    }}
                                                                                        headerClassName="bg-blue-100 font-bold" />
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {activeTab === 'profile-5' && (
                                                <div className="card">
                                                    <div className="card-header d-flex justify-content-between align-items-center">
                                                        <h5 className="mb-0">Move Tenant to Another Unit</h5>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row g-4">
                                                            <div className="col-md-6">
                                                                <div className="border p-3 rounded-3">
                                                                    <h6 className="text-secondary">Tenant Information</h6>
                                                                    <p><strong>Name:</strong> {customer.firstName} {customer.lastName}</p>
                                                                    <p><strong>Email:</strong> {customer.email}</p>
                                                                    <p><strong>Phone:</strong> {customer.phoneNumber}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="border p-3 rounded-3">
                                                                    <h6 className="text-secondary">Current Unit</h6>
                                                                    <p><strong>Unit:</strong> {customerUnits[0]?.name || 'N/A'}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div className="border p-3 rounded-3">
                                                                    <h6 className="text-secondary mb-3">Select New Unit</h6>
                                                                    <div className="row align-items-end">
                                                                        <div className="col-md-6 mb-3">
                                                                            <label className="form-label">Available Units</label>
                                                                            <Autocomplete
                                                                                multiple
                                                                                options={units} // `units` is already filtered based on customerType
                                                                                getOptionLabel={(option) => option.name || ''}
                                                                                value={selectedUnits}
                                                                                onChange={(event, newValue) => setSelectedUnits(newValue)}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label="Select Units"
                                                                                        variant="outlined"
                                                                                    />
                                                                                )}
                                                                                renderTags={(value, getTagProps) =>
                                                                                    value.map((option, index) => (
                                                                                        <Chip
                                                                                            key={option._id}
                                                                                            label={option.name}
                                                                                            {...getTagProps({ index })}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 text-end mt-4">
                                                                <button className="btn btn-outline-secondary me-2">Cancel</button>
                                                                <button className="btn btn-primary" onClick={() => {
                                                                    setConfirmAction('move');
                                                                    setConfirmDialogVisible(true);
                                                                }}>Confirm Move</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {activeTab === 'profile-6' && (
                                                <div className="card">
                                                    <div className="card-body py-0">
                                                        <ul className="nav nav-tabs profile-tabs" id="myTab" role="tablist">
                                                            <li className="nav-item">
                                                                <a className="nav-link active" id="setting-tab-1" data-bs-toggle="tab" href="#setting-1" role="tab" aria-selected="true">
                                                                    <i className="ti ti-edit me-2"></i>Edits
                                                                </a>
                                                            </li>
                                                            <li className="nav-item">
                                                                <a className="nav-link" id="setting-tab-2" data-bs-toggle="tab" href="#setting-2" role="tab" aria-selected="true">
                                                                    <i className="ti ti-edit me-2"></i>Change User Type
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="tab-content">
                                                        <div className="tab-pane fade show active" id="setting-1" role="tabpanel" aria-labelledby="setting-tab-1">
                                                            <div className="row">
                                                                <div className="col-lg-4">
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="card">
                                                                        <div className="card-header">
                                                                            <b>Update Customer</b>
                                                                        </div>
                                                                        <div className="card-body" style={{ padding: '10px' }}>
                                                                            <label>First Name</label>
                                                                            <input className="form-control mt-2" type="text"
                                                                                value={firstName} onChange={(e) => {
                                                                                    let value = e.target.value;
                                                                                    setFirstName(value)
                                                                                }}
                                                                            ></input>
                                                                        </div>
                                                                        <div className="card-body" style={{ padding: '10px' }}>
                                                                            <label>Last Name</label>
                                                                            <input className="form-control mt-2" type="text"
                                                                                value={lastName} onChange={(e) => {
                                                                                    let value = e.target.value;
                                                                                    setLastName(value)
                                                                                }}
                                                                            ></input>
                                                                        </div>
                                                                        <div className="card-body" style={{ padding: '10px' }}>
                                                                            <label>Phone Number</label>
                                                                            <input className="form-control mt-2" type="text"
                                                                                value={phoneNumber} onChange={(e) => {
                                                                                    let value = e.target.value;
                                                                                    setPhoneNumber(value)
                                                                                }}
                                                                            ></input>
                                                                        </div>
                                                                        <div className="card-body" style={{ padding: '10px' }}>
                                                                            <label>Id Number</label>
                                                                            <input className="form-control mt-2" type="text"
                                                                                value={idNumber} onChange={(e) => {
                                                                                    let value = e.target.value;
                                                                                    setIdNumber(value)
                                                                                }}
                                                                            ></input>
                                                                        </div>
                                                                        <div className="card-body" style={{ padding: '10px' }}>
                                                                            <label>Email</label>
                                                                            <input className="form-control mt-2" type="text"
                                                                                value={email} onChange={(e) => {
                                                                                    let value = e.target.value;
                                                                                    setEmail(value)
                                                                                }}
                                                                            ></input>
                                                                        </div>
                                                                        <div className="card-body" style={{ padding: '10px' }}>
                                                                            <label>KRA PIN</label>
                                                                            <input
                                                                                className="form-control mt-2"
                                                                                type="text"
                                                                                placeholder="e.g. A001234567B"
                                                                                value={kraPin}
                                                                                onChange={(e) => setKraPin(e.target.value.toUpperCase())}
                                                                            />
                                                                        </div>
                                                                        <div className="card-body" style={{ padding: '10px' }}>
                                                                            <div className="form-check">
                                                                                <input
                                                                                    id="combine-invoices"
                                                                                    type="checkbox"
                                                                                    className="form-check-input"
                                                                                    checked={combineInvoices}
                                                                                    onChange={(e) => setCombineInvoices(e.target.checked)}
                                                                                />
                                                                                <label className="form-check-label" htmlFor="combine-invoices">
                                                                                    Combine Invoices
                                                                                </label>
                                                                            </div>
                                                                            <div className="text-muted small">
                                                                                When checked, all invoices (lease, levy, water and power) are combined into a single invoice per billing period. Existing water and power invoices are added to it when you save.
                                                                            </div>
                                                                        </div>
                                                                        <div className='mt-4 mb-2' style={{ marginRight: '5px' }}>
                                                                            <button className="btn btn-primary" onClick={HandleCustomerUpdate} style={{ float: 'right' }}>Save Changes</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="tab-pane fade" id="setting-2" role="tabpanel" aria-labelledby="setting-tab-2">
                                                            <div className="row">
                                                                <div className="col-lg-4">
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div className="card">
                                                                        <div className="card-header">
                                                                            <b>Update User Type</b>
                                                                        </div>
                                                                        <div className="card-body" style={{ padding: '10px' }}>

                                                                            <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                                                                                <p className="mb-0">
                                                                                    <strong>Customer Type: </strong>{customer.customerType}
                                                                                </p>
                                                                            </div>

                                                                            <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                                                                                <p className="mb-0">
                                                                                    <strong>Residence Status: </strong>
                                                                                    <span className={`badge ms-2 ${customer.residentType === 'resident' ? 'bg-success' : 'bg-warning text-dark'}`}>
                                                                                        {customer.residentType === 'resident' ? 'Resident Homeowner' : 'Landlord (Non-Resident)'}
                                                                                    </span>
                                                                                </p>
                                                                            </div>

                                                                            {/* Show reason why button is disabled */}
                                                                            {(customer.customerType === 'tenant' || customer.status !== 'Active') && (
                                                                                <div className="mb-3">
                                                                                    <span className="badge bg-secondary">
                                                                                        {customer.customerType === 'tenant'
                                                                                            ? '🚫 Not available for tenants'
                                                                                            : '🚫 Customer is inactive'}
                                                                                    </span>
                                                                                </div>
                                                                            )}

                                                                            {/* Show conversion warning only for eligible customers */}
                                                                            {customer.customerType === 'home owner' && customer.status === 'Active' && (
                                                                                <div className="mb-3 text-muted" style={{ fontSize: '0.85rem' }}>
                                                                                    {customer.residentType === 'resident'
                                                                                        ? '⚠️ Converting to Landlord will remove this owner as the unit resident.'
                                                                                        : '⚠️ Converting to Resident Homeowner will mark this owner as the unit occupant.'}
                                                                                </div>
                                                                            )}

                                                                            <div className='mt-4 mb-2' style={{ marginRight: '5px' }}>
                                                                                <button
                                                                                    className={`btn ${customer.residentType === 'resident' ? 'btn-warning' : 'btn-success'}`}
                                                                                    onClick={HandleChangeUserType}
                                                                                    disabled={customer.customerType === 'tenant' || customer.status !== 'Active'}
                                                                                    style={{ float: 'right' }}
                                                                                >
                                                                                    {customer.residentType === 'resident' ? 'Convert to Landlord' : 'Convert to Resident'}
                                                                                </button>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Confirm dialog */}
            <ConfirmDialog
                visible={isConfirmDialogVisible}
                onHide={() =>
                    setConfirmDialogVisible(false)
                }
                message={`Are you sure you want to ${confirmAction} this Customer?`}
                onConfirm={handleConfirmAction}
            />
            <Dialog
                header={'Add Unit To Customer'}
                visible={addUnitDialog}

                onHide={() => {
                    if (addUnitDialog) setAddUnitDialogVisible(false);
                }}
            >
                <div className="row">
                    <div className="col-md-12 mt-3">
                        <div className="mb-3">
                            <label className="form-label">Unit<span style={{ color: 'red' }}>*</span></label>
                            <Autocomplete
                                multiple
                                options={units} // `units` is already filtered based on customerType
                                getOptionLabel={(option) => option.name || ''}
                                value={selectedUnits}
                                onChange={(event, newValue) => setSelectedUnits(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Units"
                                        variant="outlined"
                                    />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            key={option._id}
                                            label={option.name}
                                            {...getTagProps({ index })}
                                        />
                                    ))
                                }
                            />
                        </div>
                        <div className='mt-4' style={{ float: 'right' }}>
                            <button className="btn btn-primary" onClick={addUnoccupiedUnit}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/* Dialog for Customer Units */}
            <Dialog
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                header="Homeowner Units"
                style={{ width: "30vw" }}
                modal
            >
                <DataTable value={customerUnits} responsiveLayout="scroll">
                    <Column field="name" header="Unit Name" />
                    <Column field="tenantId" header="Tenant" body={(rowData) => (rowData.tenantId ? "Yes" : "No")} />
                    <Column header="Action" body={actionTemplate} />
                </DataTable>
            </Dialog>
            {/* Dialog for Adding next of kin */}
            <Dialog
                visible={addKinModalVisible}
                onHide={() => setAddKinModalVisible(false)}
                header="Add New Contact to Customer"
                style={{ width: "30vw" }}
                modal
            >
                <div className="row">
                    <div className="col-12 mb-3">
                        <label className="form-label">Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newKin.name}
                            onChange={(e) => setNewKin({ ...newKin, name: e.target.value })}
                            placeholder="Full Name"
                        />
                    </div>
                    <div className="col-12 mb-3">
                        <label className="form-label">Relationship</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newKin.relationship}
                            onChange={(e) => setNewKin({ ...newKin, relationship: e.target.value })}
                            placeholder="e.g., Sister, Father"
                        />
                    </div>
                    <div className="col-12 mb-3">
                        <label className="form-label">Phone</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newKin.phoneNumber}
                            onChange={(e) => setNewKin({ ...newKin, phoneNumber: e.target.value })}
                            placeholder="07XXXXXXXX"
                        />
                    </div>
                    <div className="col-12 mb-3">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            value={newKin.email}
                            onChange={(e) => setNewKin({ ...newKin, email: e.target.value })}
                            placeholder="email@example.com"
                        />
                    </div>
                    <div className="col-12 mb-3 form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="addCanReceiveInvoice"
                            checked={newKin.canReceiveInvoice}
                            onChange={(e) => setNewKin({ ...newKin, canReceiveInvoice: e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor="addCanReceiveInvoice">Can Receive Invoice</label>
                    </div>
                    <div className="col-12 d-flex justify-content-end">
                        <button
                            className="btn btn-secondary me-2"
                            onClick={() => setAddKinModalVisible(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                handleAddKin(newKin);
                                setAddKinModalVisible(false);
                            }}
                        >
                            Add Contact
                        </button>
                    </div>
                </div>
            </Dialog>
        </Layout>
    )
}

export default ViewCustomer